export const appExpandLessIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="currentColor" d="m12 8-6 6.478L7.41 16 12 11.055 16.59 16 18 14.478z"/></g></svg>`,
    name: 'expand-less' as const
};